import AccountTypeSelector from '@/user/account-type/AccountTypeSelector'
import { H2 } from '@/common/ui'
import { AccountType } from '@/common/types'
import { ReactNode } from 'react'

type Props = {
    title: string
    description?: ReactNode
    selectedAccountType: AccountType | null
    setSelectedAccountType: (accountType: AccountType | null) => void
    isTrust: boolean
    setIsTrust: (isTrust: boolean) => void
    supportedAccountTypes: AccountType[]
    showDisabledTrustOption?: boolean
    showDisabledCompanyOption?: boolean
    disabledOptionBadgeText?: string
    useThirdPersonCopy?: boolean
}

export function ApplicationAccountTypeStep({
    title,
    description,
    selectedAccountType,
    setSelectedAccountType,
    isTrust,
    setIsTrust,
    supportedAccountTypes,
    showDisabledTrustOption,
    showDisabledCompanyOption,
    disabledOptionBadgeText,
    useThirdPersonCopy,
}: Props) {
    return (
        <div className="w-full flex flex-col justify-start items-start gap-6">
            <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
                <H2 className="self-stretch justify-start text-brand-forest text-3xl font-normal font-['Serious Sans'] leading-10 mb-0">
                    {title}
                </H2>
                {description && (
                    <div className="self-stretch justify-start text-black text-sm font-normal font-['Inter'] leading-5">
                        {description}
                    </div>
                )}
            </div>
            <AccountTypeSelector
                selectedAccountType={selectedAccountType}
                setSelectedAccountType={setSelectedAccountType}
                isTrust={isTrust}
                setIsTrust={setIsTrust}
                supportedAccountTypes={supportedAccountTypes}
                showDisabledTrustOption={showDisabledTrustOption}
                showDisabledCompanyOption={showDisabledCompanyOption}
                disabledOptionBadgeText={disabledOptionBadgeText}
                useThirdPersonCopy={useThirdPersonCopy}
            />
        </div>
    )
}
